<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    const token = localStorage.getItem("vce-token-push");
    const companyId = localStorage.getItem("company_id") * 1;
    if (token) {
      this.$router.replace({
        path: companyId ? "/companyCircle" : "/chatNew",
      });
    } else {
      this.$router.replace({
        path: "/login",
      });
    }
  },
};
</script>

<style scoped></style>
